export default __webpack_public_path__ + "static/media/IMG_0042.03b3f30f.JPG";